<template>
  <el-card class="login-form-layout">
    <el-form>
      <h2 class="center">
        {{ handleCommon('setting.title') }}
      </h2>
      <el-form-item
        :label="handleCommon('setting.username')">
        <el-input
          v-model="username"></el-input>
      </el-form-item>
      <el-form-item
        :label="handleCommon('setting.password')">
        <el-input
          v-model="password"
          show-password
          @keyup.enter.native="handleSaveData"></el-input>
      </el-form-item>
      <el-form-item style="text-align: center">
        <el-button
          :loading="saveDisable"
          type="primary"
          @click="handleSaveData">
          {{ handleCommon('setting.signin') }}
        </el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<style scoped>
.login-form-layout {
  position: absolute;
  left: 0;
  right: 0;
  width: 360px;
  margin: 140px auto;
  border-top: 10px solid #409EFF;
}
</style>

<script>
import common from '@/utils/common'

export default {
  data() {
    return {
      moduleName: 'signin',
      saveDisable: false
    }
  },
  computed: {
    username: {
      get () {
        return this.handleStateGetter('editData.username')
      },
      set (val) {
        this.handleStateSetter(`${this.moduleName}/SET_EDIT`, 'username', val)
      }
    },
    password: {
      get () {
        return this.handleStateGetter('editData.password')
      },
      set (val) {
        this.handleStateSetter(`${this.moduleName}/SET_EDIT`, 'password', val)
      }
    }
  },
  methods: {
    handleCommon(k) {
      return k.split('.').reduce((a, c) => a[c], common)
    },
    handleSaveData() {
      this.saveDisable = true
      this.$store.dispatch('signin/Signin').then(res => {
        this.$message.success(common.message.signinSuccess)
        this.$router.push({ name: 'Admin' })
      }).catch(err => {
      this.saveDisable = false
        this.$message.error(err.response.data.message)
      })
    },
    handleStateSetter(m, k, v) {
      this.$store.commit(m, { key: k, val: v })
    },
    handleStateGetter(k) {
      return eval(`this.$store.state.${this.moduleName}.${k}`)
    }
  }
}
</script>
